import { gql } from '@apollo/client';

export const AI_SEARCH = gql`
  query AISearch($input: AISearchInput!) {
    aiSearch(input: $input) {
      aiSummary
      isOffTopic
      isAiFallback
      hasRelevantData
      totalResults
      disclaimer
      searchId
      responseTimeMs
      intent
      topic
      urgency
      recommendedPlaceId
      hazardStatus
      sources {
        type
        count
      }
      communityPosts {
        id
        type
        title
        description
        location
        date
        status
        imageUrl
      }
      googlePlaces {
        id
        name
        placeId
        address
        phone
        website
        rating
        userRatingCount
        distance
        distanceMiles
        type
        coordinates
      }
      helpGuides {
        id
        key
        title
        description
        expandedInfo
      }
      hazardEvents {
        id
        title
        description
        category
        date
        sourceUrl
        coordinates
      }
      poisonHotline {
        name
        phone
        region
        feeNote
        url
      }
    }
  }
`;
